import { FunctionComponent } from 'react'
import { Switch } from 'react-router-dom'

import Route from '../../../shared/routes/Route'
import { CreateMotoristaFactory } from '../factories/CreateMotorista'
import { ListMotoristaFactory } from '../factories/ListMotoristas'
import { UpdateMotoristaFactory } from '../factories/UpdateMotorista'
import { MotoristasProvider } from '../hooks/useMotoristas'

const MotoristasRoutes: FunctionComponent = () => {
  return (
    <Switch>
      <Route
        path="/motoristas"
        isPrivate
        exact
        component={ListMotoristaFactory}
      />
      <Route
        path="/motoristas/edit"
        isPrivate
        exact
        component={UpdateMotoristaFactory}
      />
      <MotoristasProvider>
        <Route
          path="/motoristas/new"
          isPrivate
          exact
          component={CreateMotoristaFactory}
        />
      </MotoristasProvider>
    </Switch>
  )
}

export default MotoristasRoutes
